import { useGetCollectionsHook } from "../hooks/useGetCollectionsHook";
import {
  formatCollectionOptions,
  getCollections,
} from "../helpers/collections.helper";
import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { Predicates } from "../../../libraries/predicates/predicates";
import OptionFormatter from "../../../components/OptionFormatter";
import AsyncSelect from "react-select/async";
import {
  DebounceContext,
  DebounceContextType,
} from "../../../context/DebounceContext";
import { CreateArtworkCollectionState } from "../state/collection/create/data";

interface IArtworkCollectionAsyncSelectProps{
  onChanged: (...args:any[]) => void,
  value?: CreateArtworkCollectionState,
  isDisabled?:boolean,
  isMandatory?: boolean,
  label?:string,
}

export const ArtworkCollectionAsyncSelect = ({isDisabled=false, isMandatory=false, onChanged, value, label}:IArtworkCollectionAsyncSelectProps) => {

  const [searchCollection, setSearchCollection] = useState("")

  const collectionSearch = useMemo(() => {
    return { status: "APPROVED", search:"" };
  }, []);

  const {
    data: collections,
    isLoading: isCollectionsLoading,
    getCollection,
  } = useGetCollectionsHook({ search: collectionSearch });

  const collectionsOptions = getCollections(collections?.results);
  const { searchDebounce } = useContext<DebounceContextType>(DebounceContext);
  const fetchCollections = useCallback(async (value: any, callback:any) => {

    const response = await getCollection({
      search: { status: "APPROVED", search: value },
    });

    callback(getCollections(response.results)?? []);
  }, [getCollection]);

  const handleUpdateMolds = (e:any) => {
    onChanged(e ? e.value : null)
  }



  return (
    <>
      <label className="form-label">
        {label ?? "Artwork Collection "}
        {isMandatory && (
          <span className="red-text fw-bold">*</span>
        )}
      </label>
      <AsyncSelect
        name="collection"
        value={
          Predicates.isNotNullAndNotUndefined(value)
            ? formatCollectionOptions(value)
            : null
        }
        onChange={handleUpdateMolds}
        defaultOptions={collectionsOptions}
        loadOptions={(input, callback) => {
          searchDebounce(
            fetchCollections,
            input,
            getCollections(collections?.results),
            callback,
          );
        }}
        formatOptionLabel={OptionFormatter}
        isLoading={isCollectionsLoading}
        isClearable
        isSearchable
        placeholder="(min 3 characters)"
        classNamePrefix="react-select"
        isDisabled={isDisabled}
      />
    </>
  );
}